import { array, object, string } from "yup";

export const PaymentSetInformationSchema = object({
    paymentSetDesc: string()
        .required("Ödeme Kuralı Açıklaması zorunludur"),
})